export { WordsPuzzleGameCoreModule } from './words-puzzle-game-core.module';
export { WordsPuzzleGameSelectorComponent } from './words-puzzle-game-selector/words-puzzle-game-selector.component';
export { WordsPuzzleGameCoreService } from './words-puzzle-game-core.service';
export { IWordsPuzzleGame } from './words-puzzle-game.interface';
